import { createContext, useContext } from 'react';

export const defaultLabels: IApplicationTranslation = {
  applications: {
    headers: {
      pageheader: '',
      vacant: '',
      screenreader_active: '',
      former: '',
      cancelled: '',
      cancelled_help: '',
    },
    application: {
      header: {
        quota1: '',
        quota2: '',
        quota12: '',
        priority: '',
        area_code: '',
      },
      status: {
        pending: '',
        pending_text: '',
        fulfilled: '',
        fulfilled_conditional: '',
        fulfilled_text: '',
        fulfilled_text_vacant: '',
        not_fulfilled: '',
        not_fulfilled_text: '',
        not_fulfilled_button: '',
        offered: '',
        offered_conditional: '',
        offered_text: '',
        standby: '',
        offered_conditional_standby: '',
        not_offered: '',
        accepted: '',
        rejected: '',
        responded_text: '',
        cancelled: '',
        cancelled_text: '',
      },
      details: {
        quota1_quotient: '',
        quota1_recalculated: '',
        quota2_quotient: '',
        winter: '',
        standby: '',
        tooltip: '',
        quotient_header: '',
        quotient_text: '',
        quotient_text_remark: '',
      },
      modal: {
        quota1_recalculated_header: '',
        quota1_recalculated_text: '',
        quota2_header: '',
        quota2_text: '',
        quota2_calculation_header: '',
        quota2_note: '',
        quota2_calculation_link: '',
        quota2_table: {
          subject: '',
          grades: '',
          average: '',
          average_total: '',
        },
        winter_header: '',
        winter_text: '',
        standby_header: '',
        standby_text: '',
        priority_header: '',
        priority_text: '',
        priority_callout_header: '',
        priority_callout_text: '',
        not_fulfilled_header: '',
        not_fulfilled_text: '',
      },
    },
    tabs: {
      applications: '',
      personal_info: '',
    },
  },
  personal_info: {
    button_courses: '',
    header: {
      quotient: '',
      exam: '',
      contact: '',
      contact_help: '',
    },
    modal: {
      courses_header: '',
      courses_caption: '',
      table_header_course: '',
      table_header_status: '',
      statuses: {
        failed: '',
        conditional: '',
        exemption: '',
        passed: '',
        failed_explanation: '',
        conditional_explanation: '',
        exemption_explanation: '',
        passed_explanation: '',
      },
    },
    empty_state: {
      exam: '',
      email: '',
      email_help: '',
      courses: '',
      courses_help: '',
    },
  },
  place_offer: {
    preheader: '',
    yes: '',
    no: '',
    deadline: '',
    startdate: '',
    header: {
      conditional: '',
      conditional_winter: '',
      winter: '',
      standby: '',
      conditional_standby: '',
      standby_conditional_winter: '',
      standby_winter: '',
      no_offer: '',
    },
    no_modal: {
      header: '',
      text: '',
      confirm: '',
      cancel: '',
    },
    standby_explanation: '',
    rejected_explanation: '',
    multiple_explanation: '',
    conditional_explanation: '',
    keep_standby: '',
    available_header: '',
    available_link: '',
  },
  receipt: {
    applications_link: '',
    animation_replay: '',
    regret_help: '',
    header: {
      accepted: '',
      rejected: '',
    },
    bullets: {
      accepted: '',
      rejected: '',
      startdate_summer: '',
      startdate_winter: '',
      conditional: '',
      mail_summer: '',
      mail_winter: '',
      mail_invalid: '',
      email_receipt: '',
    },
    studystart: {
      specific_link: '',
      generic_link: '',
      multiple_locations: {
        header: '',
        link: '',
      },
    },
    email: {
      resend: '',
      success: '',
      failure: '',
    },
    new_student: {
      header: '',
      text: '',
      button: '',
      notice: '',
    },
    studerendePlus3mdr_MitID_OTP_AzureAD: {
      header: '',
      text: '',
      button: '',
    },
  },
  menu: {
    language: '',
    profile_language: '',
    receipt: '',
    applications: '',
    quota2: '',
    callout_header: '',
    callout_text: '',
  },
  footer: {
    headline: '',
    text: '',
    compliance_accessibility: '',
    compliance: {
      cookies: '',
      privacy: '',
    },
  },
  login: {
    activate: {
      header: '',
      text: '',
      link_text: '',
    },
    login: {
      header: '',
      link_text: '',
      forgot: '',
    },
    support: {
      header: '',
      text: '',
    },
  },
  empty: {
    outside_period: {
      header: '',
      text: '',
    },
    none_applicant: {
      header: '',
      text: '',
      impersonate_header: '',
      impersonate_text: '',
    },
    no_applications: {
      header: '',
      text: '',
    },
  },
  impersonation: {
    label: '',
    input_label: '',
    activated_header: '',
    activated_text: '',
    screenreader_header: '',
    select: {
      label: '',
      option_cpr: '',
      option_email: '',
      option_auid: '',
      option_phase_outside: '',
      option_phase_current: '',
      option_phase_1: '',
      option_phase_2: '',
      option_phase_3: '',
      phase_label: '',
    },
    button: {
      confirm: '',
      abort: '',
      hide: '',
      show: '',
    },
    log: {
      button: '',
      modal: {
        header: '',
        no_response: '',
        login_label: '',
        answer_label: '',
        receipt_label: '',
        role_assignment_label: '',
        answer_error: '',
        receipt_error: '',
        receipt_queue: '',
        role_assignment_error: '',
        role_assignment_queue: '',
        accepted: '',
        rejected: '',
        sent: '',
        assigned: '',
        no_logins: '',
      },
    },
  },
  error: {
    applicant: {
      header: '',
      text: '',
    },
    applications: {
      header: '',
      text: '',
    },
    impersonation: {
      header: '',
      text: '',
    },
    response_to_offer: {
      failed: {
        header: '',
        text: '',
      },
      already_saved: {
        header: '',
        text: '',
      },
    },
    toast_dismiss_button: '',
    critical: {
      header: '',
      text: '',
    },
  },
  page: {
    url: '',
    login: '',
    applications: '',
    receipt: '',
    description_login: '',
  },
  email: {
    sender_name: '',
    accepted: {
      subject: '',
      body: '',
      conditional_note: '',
      student_orientation: '',
      student_orientation_multiple_locations: '',
    },
    rejection: {
      subject: '',
      body: '',
    },
  },
  url: {
    generic_newstudent_orentationpage: '',
    vacant_student_places: '',
  },
  message: {
    unitest: {
      header: '',
      text: '',
      btn: '',
    },
  },
  unitest: {
    header: '',
    text: '',
  },
  generics: {
    navigation: {
      local: {
        toggle: '',
      },
      global: {
        toggle: '',
      },
    },
    sub_nav: {
      profile_settings: '',
      toggle_not_signed_in: '',
      switch_language: '',
      toggle_aria_label: '',
      change_language: '',
      change_password: '',
      notifications: {
        subject_passed: '',
        mark_as_read: '',
        subject_failed: '',
        empty: '',
        header: '',
      },
    },
    modal: {
      close: '',
    },
    callout: {
      text: {
        try_again: '',
      },
    },
    authentication: {
      sign_out: '',
      sign_in: '',
    },
    user: {
      au_id: '',
      student_registration_number: '',
      copy_student_number: '',
      copy_auid: '',
    },
    actions: {
      save: '',
      cancel: '',
      edit: '',
    },
    validation: {
      confirmed: '',
    },
    toolbar: {
      toggle: '',
    },
    accessibility: {
      horizontal_scroll: {
        keyboard_instructions: '',
        forward: '',
        backward: '',
      },
      stepper: {
        header: {
          with_procesname: '',
          no_procesname: '',
        },
      },
    },
    page_error: {
      header: '',
      text: '',
    },
    copy_to_clipboard: {
      copied: '',
      label_prefix: '',
    },
    forms: {
      character_count: {
        overflow: {
          message: {
            recommended: '',
            allowed: '',
          },
          count: {
            recommended: {
              one: '',
              other: '',
            },
            allowed: {
              one: '',
              other: '',
            },
          },
        },
        count_down: {
          one: '',
          other: '',
        },
      },
    },
  },
};

export const importJson = <T>(filename: string, lang: string): Promise<T> => import(`../i18n/${lang}/${filename}.json`);

export const TranslationsContext = createContext<IApplicationTranslation>(defaultLabels);
// eslint-disable-next-line max-len
export const useTranslationsContext = (): IApplicationTranslation => useContext(TranslationsContext);
